import { SET_GLOBAL_LOADING } from '../actions/app-ui';

const initialState = {
  globalLoading: false
};

const appUiReducerStrategy = {
  [SET_GLOBAL_LOADING]: (state, { globalLoading }) => ({
    ...state,
    globalLoading
  })
};

const appUiReducer = (state = initialState, action) => {
  const reducer = appUiReducerStrategy[action.type];
  return (reducer && reducer(state, action)) || state;
};

export default appUiReducer;
